module.exports = __webpack_public_path__ + "media/images/mindset/content-image-4017f5254b4dbdfad8b5fb62a21e9208.png";